import { render, staticRenderFns } from "./SplunkReader.vue?vue&type=template&id=9fc0bd0a"
import script from "./SplunkReader.vue?vue&type=script&lang=ts"
export * from "./SplunkReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports